import clsx from 'clsx'
import {useFormik} from 'formik'
import React from 'react'
import {Button, Modal} from 'react-bootstrap'
import * as Yup from 'yup'
import HelpBubble from '../utils/HelpBubble'

const proffessionalSummarySchema = Yup.object().shape({
  proffessionalSummary: Yup.string()
    .min(10, 'Minimum 10 symbols')
    .max(350, 'Maximum 350 symbols')
    .required('This field is required'),
})

const initialValues = {
  proffessionalSummary:
    "Hi there, I'm here to help you map your ideas into reality. By hiring me you'll get a dedicated, passionate programmer that strives to bring your ideas alive. I make friction removing, problem-solving product with high usability rate. You are only one handshake away from an amazing app ",
}
type Props = {
  editModal: boolean
  handleEditModal: () => void
}

function ProffessionalSummaryModal({editModal, handleEditModal}: Props) {
  const formik = useFormik({
    initialValues,
    validationSchema: proffessionalSummarySchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      try {
        //call action here
      } catch (error) {
        console.error(error)
      }
    },
  })
  return (
    <Modal show={editModal} onHide={handleEditModal} size={'lg'}>
      <Modal.Header closeButton>
        <Modal.Title>Proffessional summary</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={formik.handleSubmit} noValidate>
          <div className='py-4'>
            <HelpBubble
              icon='/media/icons/duotune/general/gen045.svg'
              text='State your years of experience, industry, or skills. People also talk about their
              achievements or previous job experiences.'
            />

            <ul className='mr-6 mb-10 text-gray-700 fs-sm'>
              <li className='py-1 fs-sm'>Describe your strengths and skills</li>
              <li className='py-1 fs-sm'>Highlight projects, accomplishments and education</li>
              <li className='py-1 fs-sm'>Keep it short and make sure it's error-free</li>
            </ul>
          </div>
          <div>
            <textarea
              {...formik.getFieldProps('proffessionalSummary')}
              className={clsx(
                'form-control form-control-solid mb-8',
                {
                  'is-invalid':
                    formik.touched.proffessionalSummary && formik.errors.proffessionalSummary,
                },
                {
                  'is-valid':
                    formik.touched.proffessionalSummary && !formik.errors.proffessionalSummary,
                }
              )}
              name='proffessionalSummary'
              rows={5}
              placeholder='Place your proffessional summary here'
            ></textarea>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={handleEditModal}>
          Close
        </Button>
        <Button
          type='submit'
          disabled={formik.isSubmitting || !formik.isValid}
          variant='primary'
          onClick={handleEditModal}
        >
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ProffessionalSummaryModal
